import { commonErr } from "../components/common/errors";

const initialState = {
	err: commonErr.INNIT,
	errMsg: '',
	detail: undefined,
}

export default function CarDetailRed(carDetail = initialState, action) {

	switch (action.type) {
		
		case "GET_CAR_DETAIL_PENDING": {
			return {
					...carDetail,
				err: commonErr.LOADING
			}
		}
		case "GET_CAR_DETAIL_REJECTED": {
			return {
					...carDetail,
					err: commonErr.FAIL
			}
		}
			
		case "GET_CAR_DETAIL_FULFILLED": {
				
			const data = action.payload.data.data;
            const errorMessage = action.payload.data.errorMessage
            const errorCode = action.payload.data.error
			if (data) {
				return {
						...carDetail,
						err: commonErr.SUCCESS,
						errorCode: errorCode,
						errMsg: errorMessage,
						detail: {
							info: data.car,
							profiles: data.profiles,
							cars: data.cars, 
							relatedCars: data.relatedCars,
							reviews: data.reviews,
							moreReview: data.moreReview,
							dateNotAvail: data.dateNotAvail
							
						}
				}
			} else {
				return {
					...carDetail,
					err: commonErr.FAIL
				}
			}
			
		}
		default:
			return carDetail;
	}
}